import { useEffect } from 'react';

const useAmexSession = () => {
  const amexSessionDeps = global.BROWSER ? [window.AmexSession] : [];

  useEffect(() => {
    if (global.BROWSER && window.AmexSession) {
      window.AmexSession.options({
        target: encodeURIComponent(window.location.href),
      });
    }
  }, amexSessionDeps);
};

export default useAmexSession;
